<template>
    
    <div class="main">
        <c-panel>
            <form-disciplina :paramId="$route.params.id" v-on:onSubmitDisciplina="onSubmitDisciplina"></form-disciplina>
        </c-panel>
    </div>
    
</template>
<script>

import formDisciplina from "./form"

export default {
    methods:{

        onSubmitDisciplina(){

            this.$router.push('/admin/disciplina');  
        }
    },
    components:{ formDisciplina }
}
</script>
